module.exports = __webpack_public_path__ + "img/kyc3-1.a688312f.png";